import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { agencyPeopleService, type AgencyPerson } from "./agencyPeople.service";
import { agencyPeopleKeys } from "./agencyPeople";
import { PERSON_NAME_QUERY_KEYS } from "./personName";

/** Everyone tied to the caller's agency: members plus contacts (TD-086).
 * Admin only. */
export function useAgencyPeopleQuery() {
  return useQuery({
    queryKey: agencyPeopleKeys.all,
    queryFn: () => agencyPeopleService.list(),
  });
}

/** Renames a person everywhere (one global name, TD-086). The cached team
 * list takes the new name at once, then every cached list that shows names
 * is refetched. */
export function useRenamePersonMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ personId, name }: { personId: string; name: string }) =>
      agencyPeopleService.rename(personId, name),
    onSuccess: (person) => {
      queryClient.setQueryData<AgencyPerson[]>(agencyPeopleKeys.all, (list) =>
        list?.map((row) => (row.id === person.id ? person : row)),
      );
      PERSON_NAME_QUERY_KEYS.forEach((queryKey) => {
        void queryClient.invalidateQueries({ queryKey });
      });
    },
  });
}
